import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { PasswordRefreshPersonelInfoAsync } from "redux/actions/password/Password.action";
import { IPasswordRefreshInfoState } from "models/Slices/passwordSlice.model";
import { IPasswordPersonelInfo } from "models/Password/password.model";

const initialState: IPasswordRefreshInfoState = {
  passwordInfo: null,
  loading: false,
  error: "",
  errorAlert: "",
  success: false,
  isCaptcha: false,
  firstPassChange: false,
  firstPassChangeAdmin: false,
  firstPassChangeAdminGuv: false,
  clientUID: "",
  passwordInfoTemp: {
    phoneNumber: "",
    merchantNo: "",
  },
};

export const PasswordRefreshSlice = createSlice({
  name: "passwordRefresh",
  initialState,
  reducers: {
    setFirstPassChange: (state, action: PayloadAction<boolean>) => {
      state.firstPassChange = action.payload;
    },
    setFirstPassChangeAdmin: (state, action: PayloadAction<boolean>) => {
      state.firstPassChangeAdmin = action.payload;
    },
    setFirstPassChangeAdminGuv: (state, action: PayloadAction<boolean>) => {
      state.firstPassChangeAdminGuv = action.payload;
    },
    setClientUID: (state, action: PayloadAction<string>) => {
      state.clientUID = action.payload;
    },
    resetPassRefInfo: () => initialState,
    tempPersonelInfo: (state, action: PayloadAction<object>) => {
      state.passwordInfoTemp = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(PasswordRefreshPersonelInfoAsync.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        PasswordRefreshPersonelInfoAsync.fulfilled,
        (state, action: PayloadAction<IPasswordPersonelInfo>) => {
          state.loading = false;
          state.passwordInfo = action.payload;
          state.success = state.passwordInfo.Confirm; //&& state.passwordInfo?.DialogBoxes.length === 0 ? true : false;
          state.isCaptcha = !!action.payload.Captcha?.length;
        }
      )
      .addCase(
        PasswordRefreshPersonelInfoAsync.rejected,
        (state, action: any) => {
          state.loading = false;
          if (
            action.error?.message === "COR-94464" ||
            action.error?.message === "COR-94466"
          ) {
            state.errorAlert = action.error?.message;
          } else {
            state.error = action.error?.message;
          }
          state.passwordInfo = null;
          state.success = false;
        }
      );
  },
});

export const {
  setFirstPassChange,
  setFirstPassChangeAdmin,
  setFirstPassChangeAdminGuv,
  resetPassRefInfo,
  setClientUID,
  tempPersonelInfo,
} = PasswordRefreshSlice.actions;

export default PasswordRefreshSlice.reducer;
